import React, { Component } from "react";
import ReactApexChart from "react-apexcharts";

export class ReporteDespachoChart extends Component {
    constructor(props) {
        super(props);
        console.log("props.data.items",props)
        this.state = {

            series: [...props.data.items],
            options: {
                chart: {
                    type: 'bar',
                    height: 400,
                    stacked: true,
                },
                plotOptions: {
                    bar: {
                        //distributed: true, // this line is mandatory
                        borderRadius: 4,
                        horizontal: false,
                        columnWidth: '50%',
                        dataLabels: {
                            total: {
                                enabled: true,
                               
                            },
                           
                        },
                    }
                },
                colors: ["#264653", "#2a9d8f", "#e9c46a", "#f4a261", "#e76f51", "#90be6d", "#277da1", "#219ebc"],
                fill: { opacity: 1},
                dataLabels: {
                    enabled: true,
                },
                xaxis: {
                    categories: props.data.semanas,
                    title: {
                        text: 'Semanas',
                        style: {
                            fontFamily: 'inherit',
                            fontWeight: 'bold',
                        },
                        offsetY: 80,
                    },
                },
                yaxis: [{
                    title: {
                        text: 'Cantidad de contenedores',
                        style: {
                            fontFamily: 'inherit',
                            fontWeight: 'bold',
                        }
                    },

                }],
                //title: {
                //    text: 'Contenedores por destino',
                //    floating: true,
                //    //offsetY: 330,
                //    align: 'left',
                //    style: {
                //        fontFamily: 'inherit',
                //        fontWeight: 'inherit',
                //        fontSize: '18px'
                //    }
                //}
            },


        };
    }

    render() {
        return (



            <div id="chart" className="">
                <h3 className="ms-2">Contenedores por destino</h3>
                <ReactApexChart options={this.state.options} series={this.state.series} type="bar" height={430} />
            </div>



        );
    }
}
